"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CannabinoidLocationModeContract = exports.CannabinoidProfileMode = exports.LotContract = exports.LotMetaDataContract = exports.BaseLotContract = void 0;
const shared_1 = require("@getgreenline/shared");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const lodash_1 = require("lodash");
class BaseLotContract {
}
exports.BaseLotContract = BaseLotContract;
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], BaseLotContract.prototype, "batchNumber", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsInt)({ each: true }),
    (0, class_transformer_1.Transform)((params) => {
        const value = (0, shared_1.transformCaseInsensitive)(params);
        return value || [];
    }),
    (0, class_transformer_1.Expose)()
], BaseLotContract.prototype, "locationIds", void 0);
class LotMetaDataContract {
}
exports.LotMetaDataContract = LotMetaDataContract;
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], LotMetaDataContract.prototype, "metaKey", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], LotMetaDataContract.prototype, "metaValue", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], LotMetaDataContract.prototype, "createdBy", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Date),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], LotMetaDataContract.prototype, "createDate", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], LotMetaDataContract.prototype, "updatedBy", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Date),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], LotMetaDataContract.prototype, "updateDate", void 0);
class LotContract extends BaseLotContract {
}
exports.LotContract = LotContract;
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], LotContract.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], LotContract.prototype, "productId", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsInt)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], LotContract.prototype, "companyId", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => LotMetaDataContract),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], LotContract.prototype, "metaData", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)((params) => {
        const value = (0, shared_1.transformCaseInsensitive)(params);
        return (0, lodash_1.isNil)(value) ? null : value;
    }),
    (0, class_transformer_1.Expose)()
], LotContract.prototype, "isLocationCannabinoid", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], LotContract.prototype, "createdBy", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Date),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], LotContract.prototype, "createDate", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], LotContract.prototype, "updatedBy", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Date),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], LotContract.prototype, "updateDate", void 0);
var CannabinoidProfileMode;
(function (CannabinoidProfileMode) {
    CannabinoidProfileMode["LOT"] = "lot";
    CannabinoidProfileMode["LOCATION"] = "location";
})(CannabinoidProfileMode || (exports.CannabinoidProfileMode = CannabinoidProfileMode = {}));
// Decorated class mirroring LotContract: extends BaseLotContract (which supplies the
// decorated batchNumber + locationIds), adds the remaining IBaseLot fields + mode.
class CannabinoidLocationModeContract extends BaseLotContract {
}
exports.CannabinoidLocationModeContract = CannabinoidLocationModeContract;
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], CannabinoidLocationModeContract.prototype, "productId", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsInt)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], CannabinoidLocationModeContract.prototype, "companyId", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsEnum)(CannabinoidProfileMode),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((params) => (0, shared_1.transformCaseInsensitive)(params))
], CannabinoidLocationModeContract.prototype, "mode", void 0);
//# sourceMappingURL=lot.js.map